window.Timeline = {

    initTimeline: function (file, action, idblock) {
        Timeline.getTimeline(file, action, idblock, true);
        $('.cd-container').on('scroll', function () {
            if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                Timeline.getTimeline(file, action, idblock);
            }
        });
    },

    getTimeline: function (file, action, idblock, forFirstTime) {
        var forFirstTime = forFirstTime == undefined ? false : forFirstTime;
        var $listing = $('#' + idblock);

        var params = new Object;

        params.page = forFirstTime ? '1' : parseInt($listing.find('#cd-timeline').attr('page'), 10);
        params.linkedid = $listing.find('#cd-timeline').attr('linkedid');
        params.linkedtype = $listing.find('#cd-timeline').attr('linkedtype');
        params.action = action;

        MyFacture.post(
            file,
            params,
            function (data) {
                Timeline.getListingCallback(data, idblock, forFirstTime);
                Qtip.init();
                // REMOVE OTHER MONTH DISPLAY IN TIMELINE => WE KEEP JUST ONE OCCURENCE
                var months = $listing.find('.cd-timeline-month');
                var monthsOK = [];
                months.each(function () {
                    var currentMonthKey = $(this).attr('monthkey');
                    if ($.inArray(currentMonthKey, monthsOK) == -1) {
                        monthsOK.push(currentMonthKey);
                    } else {
                        $(this).remove();
                    }
                });
            },
            'json'
        );
    },

    getListingCallback: function (data, idblock, clean) {
        var $listing = $('#' + idblock);
        var clean = clean == undefined ? false : clean;

        if (clean) {
            $listing.find('#cd-timeline').attr('page', '1');
            $listing.find('#cd-timeline').empty();
        }

        if (data) {
            if (data.listing != '') {
                $listing.find('#cd-timeline').append(data.listing);
            } else {
                $listing.find('.cd-timeline-more').html(Loc.g('Plus d‘éléments à afficher'));
            }
            var currentPage = parseInt($listing.find('#cd-timeline').attr('page'), 10) + 1;
            $listing.find('#cd-timeline').attr('page', currentPage);

        }
    },
}